import { render } from "./AppendComponentsModal.vue?vue&type=template&id=273a2369&scoped=true"
import script from "./AppendComponentsModal.vue?vue&type=script&lang=js"
export * from "./AppendComponentsModal.vue?vue&type=script&lang=js"

import "./AppendComponentsModal.vue?vue&type=style&index=0&id=273a2369&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273a2369"]])

export default __exports__